export const theme: any = {
  useCustomProperties: false,
  breakpoints: ['480px', '768px', '1024px', '1092px', '1198px', '1280px'],
  colors: {
    text: '#000',
    background: '#fff',
    primary: '#07c',
    secondary: '#30c',
    muted: '#f6f6f9',
    gray: 'rgba(76, 87, 97, 0.5)',
    blue: '#13284c',
    red: '#df0b0b',
    lightGray: 'rgba(32, 37, 41, 0.5)',
    link: 'rgba(25, 85, 165, 1)',
    olive: '#9a9d95',
    slateGrey: '#5f6367',
    beige30: 'rgba(168, 151, 134, 0.3)',
    veryLightGrey: '#eaeaea',
    darkGray: '#202529',
    successGreen: '#51cc85',
  },
  fonts: {
    body: 'Open Sans, sans-serif',
    heading: 'IBM Plex Serif, serif',
    label: 'IBM Plex Sans, sans-serif',
    workSans: 'Work Sans, sans-serif',
  },
  fontSizes: [
    '0.75em',
    '0.8125em',
    '0.875em',
    '1em',
    '1.125em',
    '2em',
    '2.375em',
    '2.5em',
  ],
  fontWeights: {
    body: 400,
    heading: 700,
    bold: 700,
    headline: 600,
    label: 500,
  },
  lineHeights: {
    body: 1.75,
    label: 1.25,
  },
  space: [0, 4, 8, 14, 16, 18, 32, 64, 128, 256, 512], // [0px, 15px, 20px, 30px, 40px]
  sizes: {
    avatar: 48,
  },
  radii: {
    default: 4,
    circle: 99999,
  },
  shadows: {
    card: '0 0 4px rgba(0, 0, 0, .125)',
  },
  // rebass variants
  text: {
    pageHeading: {
      fontFamily: 'label',
      color: 'blue',
      fontWeight: 600,
      lineHeight: 0.9,
      fontSize: 48,
    },
    headline: {
      fontFamily: 'heading',
      lineHeight: 'label',
      letterSpacing: ['normal', '-1.25px'],
      color: 'blue',
      fontWeight: 'headline',
      fontSize: [5, 7],
    },
    headline10: {
      fontFamily: 'label',
      fontSize: '1em',
      fontWeight: 300,
      lineHeight: 1.5,
      letterSpacing: '1px',
      color: 'olive',
      textDecoration: 'underline',
    },
    headline11: {
      fontFamily: 'body',
      fontSize: '1em',
      lineHeight: 1.75,
      color: '#202529',
    },
    subHeader: {
      fontFamily: 'label',
      lineHeight: 'label',
      letterSpacing: '1px',
      color: 'blue',
      fontWeight: 'headline',
      fontSize: 4,
      textTransform: 'uppercase',
    },
    body: {
      fontFamily: 'body',
      fontSize: '16px',
      lineHeight: 'body',
      color: '#202529',
    },
    pullQuote: {
      fontFamily: 'label',
      fontSize: ['32px', '38px'],
      fontWeight: 'label',
      lineHeight: [1.22, 1.13],
      color: 'blue',
    },
    caption: {
      fontFamily: 'label',
      fontSize: 3,
      lineHeight: 1.5,
      color: '#20252966',
    },
    label: {
      topic: {
        fontFamily: 'label',
        letterSpacing: '0.7px',
        fontSize: 2,
        fontWeight: 'label',
        color: 'red',
        textTransform: 'uppercase',
      },
    },
    type: {
      fontSize: 2,
      fontFamily: 'label',
      color: 'gray',
    },
    source: {
      fontSize: 2,
      fontFamily: 'label',
      lineHeight: 1.38,
      color: 'lightGray',
    },
    byline: {
      fontSize: 2,
      fontFamily: 'label',
      color: 'lightGray',
      opacity: 0.9,
    },
    date: {
      fontSize: 2,
      fontFamily: 'label',
      color: 'lightGray',
      opacity: 0.9,
    },
    h2: {
      fontFamily: 'label',
      color: '#212529',
      fontSize: '24px',
      letterSpacing: '-0.45px',
    },
    listicleborder: {
      borderBottom: '1px solid rgba(168, 151, 134, 0.3)',
      py: '40px',
      my: '40px',
    },
  },
  variants: {
    avatar: {
      width: 'avatar',
      height: 'avatar',
      borderRadius: 'circle',
    },
    card: {
      p: 2,
      bg: 'background',
      boxShadow: 'card',
    },
    link: {
      color: 'link',
      textDecoration: 'none',
      '&:hover': { textDecoration: 'underline' },
    },
    nav: {
      fontSize: 1,
      fontWeight: 'bold',
      display: 'inline-block',
      p: 2,
      color: 'inherit',
      textDecoration: 'none',
      ':hover,:focus,.active': {
        color: 'primary',
      },
    },
  },
  buttons: {
    primary: {
      fontWeight: 'bold',
      color: 'background',
      bg: 'primary',
      borderRadius: 'default',
    },
    outline: {
      variant: 'buttons.primary',
      color: 'primary',
      bg: 'transparent',
      boxShadow: 'inset 0 0 2px',
    },
    secondary: {
      variant: 'buttons.primary',
      color: 'background',
      bg: 'secondary',
    },
  },
  styles: {
    root: {
      fontFamily: 'body',
      fontWeight: 'body',
      lineHeight: 'body',
    },
  },
};
